module.exports = __webpack_public_path__ + "img/code-area.e35e4586.png";